export default __webpack_public_path__ + "49536cd7b8613100ecd81b47cf762b32.svg";